<div #vehicleCard>
  <button class="add-to-bidlist btn btn-link py-3s" type="button"
    data-test-id="app-add-remove-bid-list-button-e-add-remove-bid-list-button"
    (click)="handleToggleBidListClick(dealersChoice)" data-track-elem="button" data-track-name="Add to Bid List"
    allytm-click-tagged="false">
    <i [ngClass]="{ 'allycon-plus': !isOnBidList, 'allycon-success-outline': isOnBidList }"
    class="text-primary add-to-bidlist-icon" aria-hidden="true"></i>
  </button>
</div>

<ng-template #dealersChoice>
  <trap-focus [enableFocusTrap]="inModal" [focusOnFirstElem]="true" [enableArrowKeys]="true">
    <header class="modal__header">
      <h1 class="modal__title fw-bold" [attr.id]="'Dealership-title'" tabindex="-1">
      {{translations.headerDealer}}</h1>
    </header>
    <div class="modal__content dealership_options">
      <form class="control-wrapper">
        <div class="custom-control dealership-control-inline">
          <div>
            <div class="dropdown-field-label fw-bold text-uppercase">{{translations.labelDealershipDropdown}}</div>
            <trap-focus [enableFocusTrap]="enableFocusTrap" [enableArrowKeys]="true"><app-dropdown-select
              id="'dealer_dropdown_' + index" [items]="dealershipOptions" (click)="updateDealership($event.target)"
            label="'labelDealerShip'" (openChange)="onOpenChange($event)"></app-dropdown-select></trap-focus>
          </div>
          <div>
            <div class="dropdown-field-label fw-bold text-uppercase">{{translations.labelCreditLineDropdown}}</div>
            <trap-focus [enableFocusTrap]="enableFocusTrap" [enableArrowKeys]="true"><app-dropdown-select
              id="'credit_dropdown_' + index" [items]="financeSourceOptions"
              (click)="updateFinanceSource($event.target)" label="Credit Line"
            (openChange)="onOpenChange($event)"></app-dropdown-select></trap-focus>
          </div>
          @if (isDeliveryEnabled) {
            <div>
              <div class="dropdown-field-label fw-bold text-uppercase">{{ translations.labelDeliveryDropdown }}</div>
              <trap-focus [enableFocusTrap]="enableFocusTrap" [enableArrowKeys]="true"><app-dropdown-select
                id="'delivery_dropdown_' + index" [items]="deliveryOptions"
                (click)="updateDelivery($event.target)" label="Delivery"
              (openChange)="onOpenChange($event)"></app-dropdown-select></trap-focus>
            </div>
          }
        </div>
      </form>
    </div>

    <div class="modal__action d-flex">
      <button class="btn btn-primary d-block bid-buttons action-btns" (click)="submitDealership($event)"
        data-track-elem="button" data-track-name="addBidListBuyAction" id="do_add_button"
      data-test-id="app-add-remove-bid-list-button-e-modal-submit-button">{{translations.labelSubmit}}</button>

      <button class="btn btn-link d-block cancel-btn bid-buttons action-btns" (click)="closeDealership($event)"
        data-track-elem="button" data-track-name="Cancel" data-track-trigger="close" id="do_cancel_button"
      data-test-id="app-add-remove-bid-list-button-e-modal-cancel-button">{{translations.btnCancel}}</button>
    </div>

    <div class="modal-close-container position-static h-0">
      <button class="modal__close position-absolute p-0 lh-1" [attr.aria-label]="'arealabelClosemodel'" (click)="closeDealership($event)"
        data-track-elem="icon" data-track-name="Close" data-track-trigger="close" id="do_close_x_button"
        data-test-id="app-add-remove-bid-list-button-e-modal-close-button">
        <i class="allycon-glyph-close text-primary" aria-hidden="true"></i>
      </button>
    </div>
  </trap-focus>
</ng-template>
